import React, { useState } from 'react'

export default function PhotoInput({photoUrl, onFileLoad}) {
  const [dragging, setDragging] = useState(false)
  const imgUrl = photoUrl && photoUrl.includes('data:') ? photoUrl : photoUrl + '?' + Math.random()

  const fileLoaded = (files) => {
    if (files && files[0]) onFileLoad(files[0])
  }

  const handleDrag = function(e) {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') return setDragging(true)
    if (e.type === 'dragleave') return setDragging(false)
  }

  const handleDrop = function(e) {
    e.preventDefault()
    e.stopPropagation()
    setDragging(false)
    fileLoaded(e.dataTransfer.files)
  }

  return <div className='league-photo-form'>
    <div className='col-sm-12'>
      <div className='team-badge'>Team Badge</div>
      <div className='team-badge-preview'>If you do not have team badge we will assign one for you</div>
    </div>
    <div className='col-sm-12'>
      <input 
        type='file'
        accept='image/png,image/jpeg'
        id='league-photo-input'
        onChange={(e) => fileLoaded(e.target.files)}
      />
      <label 
        id='league-photo-label'
        className={dragging ? 'active' : '' }
        htmlFor='league-photo-input'
        onDragEnter={handleDrag}
        onDragOver={handleDrag}
        onDragLeave={handleDrag}
        onDrop={handleDrop}
      >
        <img src='/images/leagues/path.svg' />
        <span className='upload-button'>Upload a file</span>
        <span>PNG, JPG, up to 10MB</span>
        <span>or drag and drop</span>
      </label>
    </div>
    <div className='col-xs-12'>
      { photoUrl &&
        <div className='photo-preview'>
          <img alt='Icon' src={imgUrl} />
        </div>
      }
    </div>
  </div>
}
